import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { capturePreferenceImportFragment } from './components/preferenceTransfer'
import './styles.css'

const root = document.getElementById('root')

if (!root) {
  throw new Error('SamRouter root element was not found.')
}

const preferenceImport = capturePreferenceImportFragment(
  window.location,
  window.history,
)

createRoot(root).render(
  <StrictMode>
    <App preferenceImport={preferenceImport} />
  </StrictMode>,
)
